import React from "react";
import "./Showcase.scss";
import { H3 } from "../../ui/Typography";
import { Checkbox, RadioButton, Table, TableCell, TableRow } from "../../ui";

function ShowcaseRadio() {
  const [page, setPage] = React.useState(1);
  return (
    <>
      <div className="showcase-wrapper">
        <H3>Radio Button</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>(S)Size 16 Px</th>
                <th>(M)Size 16 Px</th>
                <th>(L)Size 16 Px</th>
              </tr>
              <tr>
                <td>Default</td>
                <td>
                  <RadioButton
                    id="opt1"
                    name="group"
                    value="option1"
                    label="Option One"
                    size="md"
                    onChange={(val) => console.log("Selected:", val)}
                  />
                </td>
                <td>
                  <RadioButton
                    id="opt3"
                    name="group"
                    value="option2"
                    label="Option Three"
                    size="lg"
                    onChange={(val) => console.log("Selected:", val)}
                  />
                </td>
                <td>
                  <RadioButton
                    id="opt2"
                    name="group"
                    value="option3"
                    label="Option Three"
                    size="xl"
                    onChange={(val) => console.log("Selected:", val)}
                  />
                </td>
              </tr>
              <tr>
                <td>Disabled</td>
                <td>
                  <RadioButton
                    id="opt1"
                    name="group"
                    value="option1"
                    label="Option One"
                    size="md"
                    disabled
                  />
                </td>
                <td>
                  <RadioButton
                    id="opt3"
                    name="group"
                    value="option3"
                    label="Option Three"
                    size="lg"
                    disabled
                  />
                </td>
                <td>
                  <RadioButton
                    id="opt3"
                    name="group"
                    value="option3"
                    label="Option Three"
                    size="xl"
                    disabled
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="showcase-wrapper">
        <H3>Checkbox</H3>
        <div className="showcase-inner">
          <Table>
            <TableRow>
              <TableCell></TableCell>
              <TableCell header>(S)Size 16 Px</TableCell>
              <TableCell header>(M)Size 16 Px</TableCell>
              <TableCell header>(L)Size 16 Px</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Default</TableCell>
              <TableCell></TableCell>
              <TableCell>
                <Checkbox
                  id="checkbox2"
                  name="checkbox2"
                  value="accepted"
                  label="Placeholder"
                  size="lg"
                  defaultChecked
                  onChange={(val) => console.log("Checked:", val)}
                />
              </TableCell>
              <TableCell>
                <Checkbox
                  id="checkbox3"
                  name="checkbox3"
                  value="accepted"
                  label="Placeholder"
                  size="xl"
                  defaultChecked={false}
                  indeterminate={true}
                  onChange={(val) => console.log("Checked:", val)}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Disabled</TableCell>
              <TableCell>
                <Checkbox
                  id="checkbox4"
                  name="checkbox4"
                  value="accepted"
                  label="Placeholder"
                  size="md"
                  disabled
                />
              </TableCell>
              <TableCell>
                <Checkbox
                  id="checkbox5"
                  name="checkbox5"
                  value="accepted"
                  label="Placeholder"
                  size="lg"
                  disabled
                />
              </TableCell>
              <TableCell>
                <Checkbox
                  id="checkbox6"
                  name="checkbox6"
                  value="accepted"
                  label="Placeholder"
                  size="xl"
                  disabled
                />
              </TableCell>
            </TableRow>
          </Table>
          <Checkbox
            id="checkbox1"
            name="checkbox1"
            value="accepted"
            label="Placeholder"
            size="md"
            defaultChecked={false}
            onChange={(val) => console.log("Checked:", val)}
          />
        </div>
      </div>
    </>
  );
}

export default ShowcaseRadio;
